export default class CesiumWidget extends Cesium.CesiumWidget {
    constructor(container, options){
        super(container, {
            creditContainer: document.createElement("div"),
            ...options
        })
    }
}